module.exports = __webpack_public_path__ + "logo_51-186c158fa2af9f57d4351a219fe4f5b6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_51.png
// module id = 1139
// module chunks = 0 1